import Vue from 'vue'
import { Form, Button, Input, Modal, message } from 'ant-design-vue'
import Storage from 'vue-ls'
import SliderCaptcha from '@/components/slider-captcha'

import './css/index.less'

Vue.use(Form)
Vue.use(Button)
Vue.use(Input)
Vue.use(Storage)
Vue.prototype.$message = message
Vue.prototype.$error = Modal.error
Vue.prototype.$success = Modal.success
Vue.use(SliderCaptcha)
